import { createApp } from 'vue';
import App from './App.vue';

// Suppress the benign "ResizeObserver loop completed with undelivered
// notifications" warning. It's a no-op the browser fires when observers
// trigger nested layout reads (Element Plus, chart libs, etc. all trip it)
// and it doesn't affect functionality.
const RESIZE_OBSERVER_LOOP_RE = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (e?.message && RESIZE_OBSERVER_LOOP_RE.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const reason = e?.reason;
  const msg = typeof reason === 'string' ? reason : reason?.message;
  if (msg && RESIZE_OBSERVER_LOOP_RE.test(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
import router from './router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from './state/store';
import menu from '../src/components/menu.vue';
import Admin from '../src/layouts/Admin.vue';
import Blank from '../src/layouts/Blank.vue';
import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from 'click-outside-vue3';
import { vMaska } from 'maska';

import VueFeather from 'vue-feather';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';

import '@/assets/scss/config/default/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';
import '@/assets/scss/brand-themes.css';

import AlertServie from './services/errors.service';

import ErrorService from './services/errorHandler.service';

import MiddlewareServie from './services/middlewre.service';
import ApiService, {BASE_URL} from './services/api.service';
import timeago from 'vue-timeago3';
import ElementPlus from 'element-plus';
// main.ts
import 'element-plus/theme-chalk/dark/css-vars.css';
import 'element-plus/dist/index.css';
import axios from 'axios';
import ganttastic from '@infectoone/vue-ganttastic';

AOS.init({
  easing: 'ease-out-back',
  duration: 1000
});

// Apply the theme + brand synchronously BEFORE Vue mounts. Doing this
// here (rather than in App.vue's mounted) guarantees data-bs-theme and
// data-brand are set before any child component reads them during its
// own setup/onMounted — otherwise initial-state checks fire too early
// and end up out of sync.
(function bootstrapAppearance() {
  try {
    const html = document.documentElement;

    let theme = localStorage.getItem('theme');
    if (!theme) {
      theme = 'dark'; // Dark is the default for new visitors.
      localStorage.setItem('theme', theme);
    }
    html.setAttribute('data-bs-theme', theme);
    html.classList.remove('light', 'dark');
    html.classList.add(theme);

    const brand = localStorage.getItem('brand') || 'indigo';
    html.setAttribute('data-brand', brand);
  } catch (_) { /* localStorage unavailable — fall back to default styles */ }
})();

// Define a pre-load check function
async function preLoadCheck() {
  try {
    // Make the request
    const response = await axios.get(BASE_URL + '/check-tenant');
    // Proceed if no error
    if (response && response.status === 200) {
      return true;
    }
  } catch (error) {
    // Redirect on error
    if (process.env.NODE_ENV === 'production') {
      window.location.href = 'https://my-tracker.com/?page=404';
    }
    return false;
  }
}

const app = createApp(App);

ApiService.init(app);
// Run the pre-load check, and only mount the app if it succeeds
preLoadCheck().then((canProceed) => {
  if (canProceed) {
    app.use(store);
    app.use(router);
    app.use(ganttastic);

    AlertServie.init(app);

    ErrorService.init();

    app.use(ElementPlus);

    app.use(BootstrapVue3);
    app.component('vue-feather', VueFeather);
    app.component('Menu', menu);
    app.component('Admin', Admin);
    app.component('Blank', Blank);
    app.directive('maska', vMaska);
    app.use(i18n);
    app.use(timeago);

    MiddlewareServie.init(router);

    app.use(vClickOutside).mount('#app');
  }
});
